

exports.__esModule = true;
exports.$ErrorRoute = undefined;

var _squid = require('squid');

require('./xo-invalid-address-error/route');

require('./xo-generic-error/route');

require('./directive');

var _logger = require('xo-beaver/dist/logger');

var $ErrorRoute = exports.$ErrorRoute = _squid.$ComponentRoute.extend('$ErrorRoute', {

    path: 'error',
    directive: 'xo-error',

    trackingData: {
        fptiState: 'error',
        trackStateExit: true
    },

    auth: false,

    query: ['code', 'data'],

    children: [{
        name: '$InvalidAddressRoute'
    }, {
        name: '$GenericErrorRoute'
    }],
    resolve: {
        action: function action($state, $populate) {
            _logger.$logger.info('checkout error');
        }
    }
});

angular.value("$ErrorRoute", $ErrorRoute);
_squid.$ComponentRoute;

_logger.$logger;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-error/route.js
// module id = ./pages/xo-error/route.js
// module chunks = 1